//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import adobeAnalyticsIcon from '@images/adobe-analytics.png';
import googleAnalyticsIcon from '@images/ga.png';
import { navigateToState } from '@react-bridge/wrappers/navigation';
import { OnboardingStepCard } from '@welcome-page/components/onboarding/steps/OnboardingStepCard';
import { OnboardingState } from '@welcome-page/components/onboarding/steps/OnboardingStepCardGrid';
import { ONBOARDING_STEP_ICON_SIZE } from '@welcome-page/constants/OnboardingConstants';

export const OnboardingAnalyticsCard = ({
  isError,
  status,
}: OnboardingState) => {
  return (
    <OnboardingStepCard
      description='Connect Google Analytics or Adobe Analytics to view commerce metrics.'
      icons={[
        <img
          alt='google analytics logo'
          height={ONBOARDING_STEP_ICON_SIZE}
          key='google-analytics-logo'
          src={googleAnalyticsIcon}
          width={ONBOARDING_STEP_ICON_SIZE}
        />,
        <img
          alt='adobe analytics logo'
          height={ONBOARDING_STEP_ICON_SIZE}
          key='adobe-analytics-logo'
          src={adobeAnalyticsIcon}
          width={ONBOARDING_STEP_ICON_SIZE}
        />,
      ]}
      onClickConnect={() => {
        void navigateToState('account-settings.analytics', {});
      }}
      showAlarmTooltip={isError}
      status={status}
      title='Analytics'
    />
  );
};
